import styled from "styled-components";

interface StatusContainerProps {
  width?: string;
}
export const StatusContainer = styled.span<StatusContainerProps>`
  width: ${({ width }) => width ?? "140px"};
  border-radius: 20px;
  padding: 5px;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
`;
